import { Location } from "@angular/common";
import { HttpStatusCode } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { ProcessRemoteControllerService } from "core/api";
import { IProcessDto } from "core/dto";
import { RemoteItemService, RemoteItemStore } from "core/remotes";
import { mapKey, pairBehaviorSubjects } from "core/rx-js";
import { LoaderService, } from "core/services";
import { tap } from "rxjs";
import { designerPaths } from "../../../designer.paths";
import { DsgDeepTranslationKey } from "../../../pipes/translate.pipe";
import { SignProcessWizardService } from "../sign-process-wizard.service";
import applyEntityLoader from "./utils/apply-entity-loader";


const processEntityLoader = applyEntityLoader('process');

@Injectable()
export class RemoteProcessService extends RemoteItemService<IProcessDto> {

  constructor(
    private readonly _location: Location,
    private readonly _signProcessWizardService: SignProcessWizardService,
    private readonly _processRemoteControllerService: ProcessRemoteControllerService,
    private readonly _loaderService: LoaderService<DsgDeepTranslationKey>,
    private readonly _router: Router
  ) {

    super();
    const processId = _signProcessWizardService.processIdSubject.value;

    const remoteCustomStore = new RemoteItemStore<IProcessDto, string>({
      keyField: 'id',
      insert: (insertDto) => processEntityLoader({
        obs: this._processRemoteControllerService.create(insertDto)
          .pipe(
            mapKey('id'),
            tap((processId) => {
              this._location.replaceState('process/' + processId)
            })
          ),
        loaderService: this._loaderService,
        methodKey: 'insert',
        subtle: true
      }),
      keyValue: processId,
      load: (id) => processEntityLoader({
        obs: _processRemoteControllerService.getOne(id).pipe(
          tap({
            error: (response) => {
              const status = response?.error?.error?.status;

              if (status.code === HttpStatusCode.Unauthorized || status.code === HttpStatusCode.Forbidden) {
                this._router.navigate([designerPaths.unauthorized])
              }
            }
          }),
        ),
        loaderService: _loaderService,
        methodKey: 'by-key',
      }),
      update: (id, updateDto) => processEntityLoader({
        obs: _processRemoteControllerService.update(id, updateDto),
        loaderService: _loaderService,
        methodKey: 'update'
      })
      ,
      remove: (id) => processEntityLoader({
        obs: _processRemoteControllerService.remove(id),
        loaderService: _loaderService,
        methodKey: 'remove'
      }),
    })

    super.setConfig({
      customStore: remoteCustomStore,
    });

    pairBehaviorSubjects(
      this.keyValueSubject,
      this._signProcessWizardService.processIdSubject
    )

    pairBehaviorSubjects(
      this._signProcessWizardService.processSubject,
      this.localItemStore.stateSubject
    )

    if (processId) {
      // this.load().subscribe()
    }




  }
}
